<template>
  <li v-show="typing" class="typing-position">
    <div class="octadesk-chat-msg octadesk-ball-pulse-sync">
      <div></div>

      <div></div>

      <div></div>
    </div>
  </li>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['typing'])
    }
  }
</script>

<style scoped>
  .typing-position {
    position: absolute;
    width: 95px;
  }

  .octadesk-chat-typing .octadesk-chat-msg.octadesk-ball-pulse-sync {
    margin-left: 0;
    border-top-left-radius: 0.1875rem;
  }

  .octadesk-chat-msg.octadesk-ball-pulse-sync {
    display: block;
    width: 46px;
    margin: 0.5rem auto 0.5rem 2.1875rem;
    background-color: #fff;
    padding-right: 0.625rem !important;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  }
</style>
